import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Dropdown, DropDownProps } from 'antd';
import { IconArrow, IconHome } from '@components/shared';

interface Props {
  className?: string;
  icon?: ReactNode;
  label: string;
  value: string;
}

export function SelectorFilter(props: Props & DropDownProps) {
  const {
    className = '',
    icon = <IconHome width={20} height={20} />,
    label,
    value,
    ...rest
  } = props;

  const chooseValue = (
    rest?.menu?.items?.find((item) => item?.key === value) as { label: ReactNode }
  )?.label;

  return (
    <Dropdown {...rest} overlayClassName="w-40 p-2">
      <div className={twMerge('flex gap-3 cursor-pointer text-start items-center', className)}>
        <span className="border border-gray-200 w-10 h-10 rounded-full flex items-center justify-center">
          {icon}
        </span>
        <div className="flex-1">
          <span className="flex items-center text-gray-700 gap-2 typography-h6">
            {label} <IconArrow />
          </span>
          <span className="typography-h5 text-gray-800 font-semibold">{chooseValue}</span>
        </div>
      </div>
    </Dropdown>
  );
}
